export const GRID_COLS = {
	fr_auto: 'grid-cols-[1fr_auto]',
	1: 'grid-cols-1',
	2: 'grid-cols-2',
	3: 'grid-cols-3',
	4: 'grid-cols-4',
	5: 'grid-cols-5',
	6: 'grid-cols-6',
	7: 'grid-cols-7',
	8: 'grid-cols-8',
	9: 'grid-cols-9',
	10: 'grid-cols-10',
	11: 'grid-cols-11',
	12: 'grid-cols-12',
} as const;

export type GridCols = keyof typeof GRID_COLS;


export const GRID_COLS_TABLET = {
	fr_auto: 'tablet:grid-cols-[1fr_auto]',
	1: 'tablet:grid-cols-1',
	2: 'tablet:grid-cols-2',
	3: 'tablet:grid-cols-3',
	4: 'tablet:grid-cols-4',
	5: 'tablet:grid-cols-5',
	6: 'tablet:grid-cols-6',
	7: 'tablet:grid-cols-7',
	8: 'tablet:grid-cols-8',
	9: 'tablet:grid-cols-9',
	10: 'tablet:grid-cols-10',
	11: 'tablet:grid-cols-11',
	12: 'tablet:grid-cols-12',
} as const;

export type GridColsTablet = keyof typeof GRID_COLS_TABLET;


export const GRID_COLS_DESKTOP = {
	fr_auto: 'desktop:grid-cols-[1fr_auto]',
	1: 'desktop:grid-cols-1',
	2: 'desktop:grid-cols-2',
	3: 'desktop:grid-cols-3',
	4: 'desktop:grid-cols-4',
	5: 'desktop:grid-cols-5',
	6: 'desktop:grid-cols-6',
	7: 'desktop:grid-cols-7',
	8: 'desktop:grid-cols-8',
	9: 'desktop:grid-cols-9',
	10: 'desktop:grid-cols-10',
	11: 'desktop:grid-cols-11',
	12: 'desktop:grid-cols-12',
} as const;

export type GridColsDesktop = keyof typeof GRID_COLS_DESKTOP;
